import React, { useContext, useEffect, useState } from 'react';
import { TextField, Button, Snackbar, Grid, Typography, Modal } from '@mui/material';
import { Alert } from '@mui/lab';
import axios from 'axios';
import CollapsibleTable from './CollapsibleTable';
import AppContext from '../context/AppContext';

const AddLocationForm = () => {
  const storedUserRole = localStorage.getItem('userRole');

    const [input, setInput] = useState({
        Name: '',
        Description: '',
        Address: '',
      });
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const { location, setLocation} = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(()=>{
    const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);     
  },[isMobile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/add/location`,
        { name: input.Name, description: input.Description, address: input.Address }
      );
      if(response.data.status == 'success'){
      setInput({...input, Name:'', Description:'', Address:''})
      setLocation([response.data.location_data, ...location])
      setMessage(response.data.message);
      setSeverity('success');
      setOpen(true);
      setOpenModal(false)
      }
    } catch (error) {
        console.log(error);
      setMessage(error.response.data.error || 'Failed to add Category');
      setSeverity('error');
      setOpen(true);
    }
  };



  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  return (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <Typography style={{ display: 'flex', justifyContent: 'flex-end', border: "none", backgroundColor: "transparent", cursor: "pointer", color: storedUserRole == 'demo' ? 'grey' :'green', fontSize: 18}} onClick={()=> storedUserRole == 'demo' ? '' : setOpenModal(true)}>+ Add Location</Typography>
            <CollapsibleTable modal={openModal} path='api/v1/beacon/get/location' location='true'/>
            <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            width:isMobile ? 300 : 600,
            maxHeight: "100%",

            overflowY: "auto",
            overflowX: "auto",
            backgroundColor: "white",
            boxShadow: 24,
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
            onClick={handleCloseModal}
          >
            <img style={{ width: 20, height: 20 }} src="/Close.png" />
          </div>
          <form onSubmit={handleSubmit} style={{ flexDirection: "column", display: "flex" }}>
      
      <TextField
        label="Name"
        name='Name'
        value={input.Name}
        onChange={(e) => handleInputChange(e)}
        margin="normal"
        required
      />
      <TextField
        label="Description"
        name='Description'
        value={input.Description}
        onChange={(e) =>  handleInputChange(e)}
        margin="normal"
      />
      <TextField
        label="Address"
        name='Address'
        value={input.Address}
        onChange={(e) =>  handleInputChange(e)}
        margin="normal"
        required
      />
      <Button type="submit" variant="contained" color="primary" >
        Add
      </Button>
     
    </form>
           
        </div>
      </Modal>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
        </Grid>
      
    </Grid>

  );
};

export default AddLocationForm;
